import { render, staticRenderFns } from "./BaseButtonSubmit.vue?vue&type=template&id=23ae9eee"
import script from "./BaseButtonSubmit.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseButtonSubmit.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports